const state = {
  domains: []
}

const mutations = {
  /**
   * 设置角色
   * @param {*} state
   * @param {*} data
   */
  SETDOMAINS (state, data) {
    state.domains = data
  }
}

export default {
  state,
  mutations
}
